import SkeletonConversationListItem from "./SkeletonConversationListItem";

interface SkeletonConversationListProps {
  /** Number of placeholder rows to show. Defaults to 6. */
  count?: number;
}

const SkeletonConversationList = ({ count = 10 }: SkeletonConversationListProps) => (
  <>
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonConversationListItem key={i} />
    ))}
  </>
);

export default SkeletonConversationList;
